import React from 'react';
import styled from 'styled-components';

import withColor from 'util/hoc/with-color';
import Caret from 'library/icons/caret.svg';

const DropdownContainer = styled.div`
  position: relative;
  background: #f5f5f2;
  border-radius: 4px;
`;

const StyledDropdown = styled.select`
&&&&& {
  -webkit-appearance: none;
  border: none;
  padding: 1.5em .5em .5em;
  width: 100%;
  outline: none;
  font-size: 1.25em;
  z-index: 1;
  background: transparent;
  transition: all .125s ease-in-out;
  margin-bottom: 0;
  border-radius: 4px;
  border-bottom: 4px solid ${props => props.borderColor};
  :invalid {
    border-color: ${props => !!props.value ? props.invalidColor : props.borderColor };
  }
  :invalid + span {
    color: ${props => !!props.value ? props.invalidColor : (props.active ? props.activeColor : '#ccc') };
  }

  &:hover {
    background: #9090901a;
  }

}
`;
const StyledDropdownLabel = styled.span`
  position: absolute;
  top: .5rem;
  left: .65rem;

  font-weight: 400;
  font-size: .75em;
  transform: translateY(0);
  transition: all .125s ease-in-out;
  color: ${props => props.active ? props.activeColor : '#797979' };
  will-change: color, font-weight, transform, font-size;
  z-index: 0;
`;

const StyledIcon = styled.span`
  color: rgba(0,0,0,0.6);
  position: absolute;
  right: 0;
  top: 1.5rem;
  height: 100%;
  margin-right: .5em;
`;

class Dropdown extends React.Component {
  state = {
    focus: false,
    value: ''
  }

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  handleChange = (e) => {
    const { onChange } = this.props;
    this.setState({
      value: e.target.value
    });
    if(onChange) onChange(e);
  }

  setFocus = () => {
    this.inputRef.current.focus();
  }

  mapOptions = (options) => options.map((option, i) => (
    <option
      key={i}
      value={option.key}
    >{option.value}
    </option>)
  );

  render() {
    const { options, name, label, value, onChange, colors, ...props } = this.props;
    const tValue = this.state.value||value||props.defaultValue;

    return (
      <DropdownContainer>
        <StyledDropdown
          aria-label={label}
          id={name}
          name={name}
          onFocus={()=>this.setState({focus:true})}
          onBlur={()=>this.setState({focus:false})}
          value={tValue}
          onChange={this.handleChange}
          active={this.state.focus||tValue}
          borderColor={colors.tertiary}
          invalidColor={colors.auxilary_5}
          ref={this.inputRef}
          {...props}
        >
          <option value="">Make a selection</option>
          {options && this.mapOptions(options)}
        </ StyledDropdown>
        <StyledDropdownLabel
          activeColor={colors.tertiary}
          active={this.state.focus||tValue}
          onClick={this.setFocus}
          htmlFor={name}
        >
          { label }
        </StyledDropdownLabel>
        <StyledIcon>
          <Caret />
        </StyledIcon>
      </DropdownContainer>
    );
  }
}

export default withColor(Dropdown);
